import React, {useContext} from 'react'
import {Grid} from '@material-ui/core'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import {useHistory} from 'react-router'

import messages from './messages'
import useStyles from './styles'
import AppButton from '../../Common/AppButton'
import PriorAuthorizationContext from '../../../contexts/PriorAuthorization/PriorAuthorization.context'

export default function CreateSuccess(props){

    const {...wrapperProps} = props
    const classes = useStyles()
    const history = useHistory()
    const {authNumber} = useContext(PriorAuthorizationContext)

    return (
        <div {...wrapperProps} style={{width: '100%', height: '100%', ...wrapperProps.style}}>
            <h1 className="pageTitle">Create PA Success</h1>
            <Grid style={{width: '100%', height: '50%', marginTop: '3rem'}} container spacing={0} justifyContent='center' >
                
                <Grid className={classes.checkIconWrapper} container justifyContent='center' item xs={12}>
                    <CheckCircleOutlineIcon className={classes.checkIcon} />
                </Grid>
                
                <Grid container justifyContent='center' item xs={12}>
                    <span className={classes.message}>
                        {messages.success}
                    </span>
                </Grid>

                <Grid container justifyContent='center' item xs={12}>
                    <span className={classes.message} >
                        {messages.getAuthTitle(authNumber)}
                    </span>
                </Grid>

                <Grid className={classes.buttonWrapper} container justifyContent='center' item xs={12}>
                    <AppButton
                        style={{width: 'fit-content'}}
                        className='btn-primary' 
                        text='CONTINUE' 
                        size='large'
                        onClick={() => history.replace('/')}
                        buttonStyle={{width: '13rem', height: '3rem', fontSize: '1rem', marginTop: '.5rem', marginBottom: '1rem'}}

                    >
                    </AppButton>
                </Grid>

            </Grid>
        </div>
    )
}